import React from "react";

import { Stack, SvgIconProps, Typography } from "@mui/material";

import { HelpBox } from "@/components/atoms";

type MessageIconProps = {
  Icon: React.ComponentType<SvgIconProps>;
  color: "primary" | "secondary" | "info" | "warning" | "success" | "error";
  message?: string;
  tooltip?: string;
};

const MessageIcon: React.FC<MessageIconProps> = ({
  Icon,
  color,
  message,
  tooltip,
}) => {
  return (
    <HelpBox title={tooltip ?? ""} placement="bottom">
      <Stack direction="row" alignItems="center" spacing={1}>
        <Icon fontSize="small" color={color} />
        {message && <Typography color={color}>{message}</Typography>}
      </Stack>
    </HelpBox>
  );
};

export default MessageIcon;
